<template>
  <v-app light>
    <v-navigation-drawer v-if="authenticated" app v-model="drawer" color="white" :mini-variant.sync="miniVariant"
      :mobile-break-point="480" :temporary="$vuetify.breakpoint.smAndDown" fixed floating class="shadow-drawer">
      <v-toolbar flat>
        <v-list class="pa-0">
          <v-list-item class="pa-0">
            <v-list-item-avatar v-if="miniVariant">
              <v-btn text transparent icon>
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </v-list-item-avatar>

            <v-list-item-content>
              <img width="150px" src="/img/acma3.jpg">
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon @click.stop="miniVariant = !miniVariant">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-toolbar>
      <v-list dense>
        <template v-for="item in allowedItems">
          <v-list-group v-if="item.children" v-model="item.model" :key="item.title" :to="!item.route ? '' : item.route"
            :prepend-icon="item.icon" no-action>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="(child, i) in item.children" :key="i" :to="child.route == '#' ? '' : child.route">
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.title" :to="item.route == '#' ? '' : item.route">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <tool-bar v-on:toggleDrawer="drawer = !drawer" :drawer="drawer" @updateDrawerApp="updateDrawer"></tool-bar>
    <v-content>
      <v-breadcrumbs large class="ml-2" v-if="breadcrumbs" :items="breadcrumbs" divider=">" />
      <v-container fluid class="dashboard">
        <v-layout row wrap mx-4>
          <v-flex xs12>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.fullPath"></router-view>
            </transition>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <feedback-message></feedback-message>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import NavMenu from '~/components/NavMenu'
import ToolBar from '~/components/ToolBar'
import FeedbackMessage from '~/components/FeedbackMessage'
import Permissions from '~/mixins/Permissions'

export default {
  mixins: [Permissions],
  components: {
    'nav-menu': NavMenu,
    'tool-bar': ToolBar,
    'feedback-message': FeedbackMessage
  },

  computed: {
    ...mapGetters({
      authenticated: 'authCheck'

    }),
    breadcrumbs() {
      return this.$route.meta !== undefined && this.$route.meta.breadcrumbs ? this.$route.meta.breadcrumbs : undefined
    }
  },

  data() {
    return {
      drawer: true,
      miniVariant: false,
      items: [
        {
          icon: 'mdi-chart-bar',
          title: 'Accueil',
          model: false,
          route: { name: 'overview' },
          permission: 'access dashboard'
        },
        {
          icon: 'mdi-home-group',
          title: 'Organisations',
          model: false,
          permission: 'view organizations',
          children: [
         
            {
              title: 'Liste des organisations',
              route: { name: 'organizations.list' },
              permission: 'view organizations',
            },
                     
            {
              title: 'Organisations non validées',
              route: { name: 'organizations.no_validate' },
              permission: 'view organizations no validate',
            }
          ]
        },
        {
          icon: 'mdi-account-group-outline',
          title: 'Acteurs',
          model: false,
          permission: 'access actors',
          children: [
            // {
            //   title: 'Créer un acteur',
            //   route: { name: 'actors.new', params: { actorId: 'new' } },
            //   permission: 'create actors'
            // },
            {
              title: 'Liste des acteurs',
              route: { name: 'actors.list' },
              permission: 'view actors'
            },
            {
              title: 'Liste des acteurs non validés',
              route: { name: 'actors.list_validate' },
              permission: 'view validate actors'
            }
          ]
        },
        {
          icon: 'mdi-calendar-month-outline',
          title: 'Evènements',
          model: false,
          permission: 'access events',
          children: [
            {
              title: 'Créer un évènement',
              route: { name: 'events.new', params: { eventId: 'new' } },
              permission: 'create events'
            },
            {
              title: 'Evènements à réaliser',
              route: { name: 'events.coming' },
              permission: 'view events'
            },
            {
              title: 'Evènements en cours',
              route: { name: 'events.in_progress' },
              permission: 'view events'
            },
            {
              title: 'Evènements réalisés',
              route: { name: 'events.past' },
              permission: 'view events'
            },
            {
              title: 'Evènements non validés',
              route: { name: 'events.validate' },
              permission: 'view validate events'
            }
          ]
        },
        {
          icon: 'mdi-settings-outline',
          title: 'Paramètres',
          model: false,
          permission: 'access settings',
          children: [
            {
              title: 'Général',
              route: { name: 'settings.general' },
              permission: 'create settings'
            },
            {
              title: 'Utilisateurs',
              route: { name: 'users.list' },
              permission: 'view users'
            },
            {
              title: 'Invitations',
              route: { name: 'invitations.list' },
              permission: 'view users'
            },
            /* {
                title: 'Modèle de carte',
                route: { name: 'settings.card_designs'}
            },*/
            {
              title: 'Pays',
              route: { name: 'settings.countries' },
              permission: 'view countries'
            },
            {
              title: 'Département',
              route: { name: 'settings.departments' },
              permission: 'view departments'
            },
            {
              title: 'Commune',
              route: { name: 'settings.municipalities' },
              permission: 'view municipalities'
            },
            {
              title: 'Arrondissement',
              route: { name: 'settings.districts' },
              permission: 'view districts'
            },
            {
              title: 'Village',
              route: { name: 'settings.towns' },
              permission: 'view towns'
            },
            {
              title: 'Maillons',
              route: { name: 'settings.maillons' },
              permission: 'view maillons'
            },
            {
              title: 'Services',
              route: { name: 'settings.services' },
              permission: 'view services'
            },
            {
              title: 'Types SAE',
              route: { name: 'settings-type-sae' },
              permission: 'view sae types'
            },
            {
              title: 'Domaines',
              route: { name: 'settings.domains' },
              permission: 'view domains'
            },
            {
              title: 'Langues',
              route: { name: 'settings.languages' },
              permission: 'view languages'
            },
            {
              title: "Types d'évènements",
              route: { name: 'settings.event_types' },
              permission: 'view event types'
            },
            {
              title: "Types d'organisateurs",
              route: { name: 'settings-organisator-types' },
              permission: 'view event types'
            },
            {
              title: "Types Thématique",
              route: { name: 'settings-thematic-type' },
              permission: 'view thematic types'
            },
            {
              title: "Niveau d'instruction",
              route: { name: 'settings.school_levels' },
              permission: 'view school levels'
            },
            {
              title: "Types d'acteurs",
              route: { name: 'settings.actor_types' },
              permission: 'view actor types'
            },
            {
              title: 'Chaînes de valeur',
              route: { name: 'settings.chains' },
              permission: 'view chains'
            },
            {
              title: 'Roles et Permissions',
              route: { name: 'settings.roles' },
              permission: 'view roles'
            }
          ]
        },
        {
          icon: 'mdi-console',
          title: 'Logs',
          route: { name: 'logs.list' },
          permission: 'access logs'
        },
        {
          icon: 'mdi-console',
          title: 'Sessions',
          route: { name: 'sessions.list' },
          permission: 'access sessions'
        },
        {
          icon: 'mdi-console-line',
          title: 'API',
          route: { name: 'keys.list' },
          permission: 'access api'
        }
      ],
      allowedItems: []
    }
  },

  created() {
    const user = this.$store.getters.authUser

    this.canAdminCreate(user)
  },
  methods: {
    updateDrawer(value) {
      this.drawer = value
    },
    canAdminCreate(user) {
      const allowed = ['super administrator']
      return this.checkAuthorization(user, allowed)
    },
    canRead(user) {
      const allowed = ['super administrator', 'administrator', 'moderator']
      return this.checkAuthorization(user, allowed)
    },
    isDevelopper(user) {
      const allowed = ['application']
      return this.checkAuthorization(user, allowed)
    },
    // determines if user has matching role
    checkAuthorization(user, allowedRoles) {
      let userRoles = null
      if (!user) { return false }
      user.user.roles.map(role => {
        userRoles = _.get(role, 'name').split(',')
      })
      this.checkAccess(user);
      return !_.isEmpty(_.intersection(allowedRoles, userRoles))
    },

    checkAccess(user) {
      const data = []
      for (const item of this.items) {
        if (user.permissions.includes(item.permission)) {
          if (item.children) {
            const children = []
            for (const child of item.children) {
              if (user.permissions.includes(child.permission)) {
                children.push(child)
              }
            }
            item.children = children
          }
          data.push(item)
        }
      }
      data.push({
        icon: 'mdi-help-rhombus-outline',
        title: 'Aide',
        route: { name: 'help' }
      },
        {
          icon: 'mdi-information-outline',
          title: 'A propos',
          route: { name: 'about' }
        })
      this.allowedItems = data;
    }
    // handleNavigation(route) {
    //   if (route.name == "actors.new") {
    //     window.location.reload();
    //   }
    // }
  }

}
</script>


<style>
:root {
  --dash-primary: #78B943;
  --dash-secondary-dark: #4F5561;
  --dash-primary-light: rgba(120, 185, 67, 0.087);
  --bg-dash: #f9f9f9;
}

.theme--light.v-application {
  background: var(--bg-dash);
}

.shadow-navbar {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.shadow-drawer {
  box-shadow: 8px 64px 4px -8px rgba(0, 0, 0, 0.2), -8px 64px 4px -8px rgba(0, 0, 0, 0.2);
}

.shadow-sidebar {
  /* box-shadow: 0px 3px 10px rgba(0, 0, 0, .2); */
  border: none;
  box-shadow: none;
}

.borderless {
  border: none !important;
}

.shadowless {
  box-shadow: none !important;
}

.dashboard-content {
  background: var(--bg-dash);
}

.bg-dash {
  background: var(--bg-dash);
}

.borderless {
  border: none !important;
}

.shadowless {
  box-shadow: none !important;
}

.v-navigation-drawer__content a.v-list-item--active.v-list-item.v-list-item--link.theme--light,
.primary--text.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light,
.v-list__tile--active.v-list__tile.v-list__tile--link.theme--light {
  border-left: 5px solid var(--dash-primary);
  background: var(--dash-primary-light);
  font-weight: bold;
  color: var(--dash-primary);
}

.v-card {
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
  border: none;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/app.vue